<template>
    <div class='ml-auto d-flex justify-space-between align-center'>
        <v-avatar color='primary ml-2' v-if='manager.name'>
            <v-img
                v-if='manager.photo && !userImageLoadError' :alt='manager.name'
                :src='store.public_url+ "/"+ manager.photo'
                @error='imageLoadError'
            >
                <template v-slot:placeholder>
                    <v-row
                        class='fill-height ma-0'
                        align='center'
                        justify='center'
                    >
                        <v-progress-circular
                            indeterminate
                            color='grey lighten-5'
                        ></v-progress-circular>
                    </v-row>
                </template>
            </v-img>
            <span
                v-else
                class='white--text caption'
            >
				{{ manager.name.substr(0, 2).toUpperCase() }}
			</span>
        </v-avatar>
        <div class='flex-grow-1'>
            <div class='name'>{{ manager.name }}</div>
            <div v-if='showPhone' class='name'>{{ manager.phone }}</div>
            <div v-if='status' class='status'>
                <v-badge
                    :color='managerStatus[status].bgColor'
                >
                    <template #badge>
						<span
                            :style='{color: managerStatus[status].color}'
                        >
							{{ managerStatus[status].label }}
						</span>
                    </template>
                </v-badge>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Manager',
        data: () => ({
            userImageLoadError: false,
            managerStatus: {
                REGISTERED: { value: 'REGISTERED', label: 'تایید نشده', bgColor: 'yellow', color: 'black' },
                COMPLETED: { value: 'COMPLETED', label: 'در انتظار تایید', bgColor: 'grey', color: '#FFFFFF' },
                APPROVED: { value: 'APPROVED', label: 'تایید شده', bgColor: 'blue', color: '#FFFFFF' }
            },
            items: []
        }),
        props: {
            showPhone:Boolean,
            manager: Object,
            status: String
        },
        computed: {
            ...mapState({ store: state => state })
        },
        methods: {
            imageLoadError() {
                this.userImageLoadError = true;
            }
        }
    };
</script>

<style scoped lang='scss'>
    .v-card {
        box-shadow: none !important;
        padding: 4px;
    }
</style>
